import { Text } from '@factorialco/deprecated-design-system'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'

import { Syncing } from 'modules/integrations/components/SyncFooter/LastSync/Syncing'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useLastSyncRunLabels } from 'modules/integrations/hooks/useLastSyncRunLabels'

const formatDate = (date: string): string => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_month_day_time')
}

export const LastSync = () => {
  const { isSyncing, lastSyncRun } = usePrivateIntegrationsSyncContext()
  const { lastSyncLabel, noLastSyncLabel } = useLastSyncRunLabels()

  if (isSyncing) return <Syncing />

  if (!lastSyncRun)
    return (
      <Text.Normal color="grey700" size="200">
        {noLastSyncLabel()}
      </Text.Normal>
    )

  return (
    <>
      <Text.Normal color="grey700" size="200">
        {lastSyncLabel()}
      </Text.Normal>
      <Text.Normal color="grey800" size="200" weight="medium">
        {formatDate(lastSyncRun.finishedAt)}
      </Text.Normal>
    </>
  )
}
